module.exports = "<div class=\"section-item\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/form-section-item/form-section-item.component.html
// module id = ../../../../../src/app/widgets/form-section/form-section-item/form-section-item.component.html
// module chunks = main